import KunLoading41 from './src/index'

KunLoading41.install = function (Vue) {
	Vue.component(KunLoading41.name, KunLoading41);
}

export default KunLoading41;
